import React, {useEffect} from 'react';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import HistoryComponent from 'src/components/elements/account/newHistoryUI/HistoryComponent';
import {filterTypes} from 'src/components/elements/account/AccountHistoryList';
import {NavigationProp} from '@react-navigation/native';
import AccountConstants from '../../../../constants/AccountConstants';

type HistoryComponentProps = {
  histroyfilter?: AccountConstants;
  navigation: NavigationProp<HistoryComponentProps>;
};

const MarketHistoryList = (props: HistoryComponentProps) => {
  useEffect(() => {
    const filterValue = filterTypes.marketPurchase;
    FirebaseAnalytic.trackEvent(
      'useEffect:componentDidMount',
      'MarketHistoryList',
      {
        ...props,
        filterValue,
      },
    );
  }, []);
  return (
    <HistoryComponent histroyfilter={filterTypes.marketPurchase} {...props} />
  );
};

export default MarketHistoryList;
